import React from 'react'
import {FaFire,FaGithub,FaCode,FaUser,FaInstagram, FaRegUser, FaLinkedin} from 'react-icons/fa';
import { FiHome,FiTwitter ,FiMenu,FiX} from "react-icons/fi";
import "./style.css"
import pic from "./assets/profile-pic.jpg"
import Card from './components/card/Card'
import FrontendStack from './components/What-I-Know/Frontend/Stack'
import BackendStack from './components/What-I-Know/Backend/Stack'
import DatabaseStack from './components/What-I-Know/Database/DatabaseStack'
import stoicimg from  "./assets/stoic.png"
import pwdencrpt from "./assets/password.jpeg"
import ecomimg from "./assets/download.png"
import blogimg from "./assets/blog.jpg"
import fly from './assets/fly.jpg'
import chat from './assets/chat.jpg'

const Portfolio =  () =>  {
    const [toggleMenu, setToggleMenu] = React.useState(false);
    return (
        <>
        <nav>
             <div className="logo">
               <p></p>
               <p></p>
            </div>
           <a title='Email Me' href='https://mail.google.com/mail/?view=cm&source=mailto&to=leelabhaskar736@gmail.com' className='contact_btn'>Contact Me <FaUser size={14} /></a>
        </nav>
        <section className='hero'>
            <aside className="sidebar">     
                <div className="aside_container">
                        <a href='#home'><FiHome size={20}  className='icon' />Home</a>
                        <a href='#projects'><FaFire  size={20}  className='icon' />Projects</a>
                        <a href='#stack'><FaCode  size={20}  className='icon' />Stack</a>
                        <a href='#contact'><FaRegUser  size={20} className='icon' /> Contact</a>
                        <h4>Socials</h4>
                        <a href='https://twitter.com/LeelaBhaskar14'  ><FiTwitter size={24} color='skyblue'  className='icon' /> Twitter</a>
                        <a href='https://github.com/leelabhaskar22'><FaGithub size={24}  color='white' className='icon' /> Github</a>
                        <a href='https://www.linkedin.com/in/leela-bhaskar-2940b1223/'><FaLinkedin size={24}  color='lightblue' className='icon' />Linkedin</a>
                </div>
            </aside>    
        <div className='container'>
  <div className='menubar'>
    <FiMenu className='menubtn' color='#ffff' fontSize={25} onClick={() => setToggleMenu(true)} />
    {toggleMenu && (
          <div className="menubar_overlay flex__center slide-bottom">
            <FiX fontSize={27} className="overlay__close" onClick={() => setToggleMenu(false)} />
            <ul className="menubar_links">
              <li><a href='#home'><FiHome size={20}  className='icon' /> Home</a></li>
              <li><a href='#projects'><FaFire  size={20}  className='icon' />Projects</a></li>
              <li><a href='#contact'><FaRegUser  size={20} className='icon' /> Contact</a></li>
              <h4>Socials</h4>
              <li><a href='https://twitter.com/LeelaBhaskar14'  ><FiTwitter size={24} color='skyblue'  className='icon' /> Twitter</a></li>
              <li><a href='https://github.com/leelabhaskar22'><FaGithub size={24}  color='white' className='icon' /> Github</a></li>
              <li><a href='https://www.linkedin.com/in/leela-bhaskar-2940b1223/'><FaLinkedin size={24}  color='lightblue' className='icon' />Linkedin</a></li>
            </ul>
          </div>
        )}
  </div>   
    <div id='home' className='profile_container'>
        <div className='profile'>
            <img src={pic} alt='profilepic' / >
            <h2 style={{color:'#fff'}}>Leela Bhaskar </h2>
        </div>
       
    </div>
    <div id='projects' className='projects section'>
        <h3>Projects</h3>
        <div className='projects-card'>
        <a target='_blank' href='https://www.stoicgpt.in' ><Card image={stoicimg} title='StoicGPT' stack="OpenAI, NextJs14, Tailwind CSS" /></a> 
           <a target='_blank' href='https://github.com/leelabhaskar22/Blogger'><Card image={blogimg} title='Blogging ' stack='ReactJs ,Firebase Auth' /></a>
           <a target='_blank' href='https://github.com/leelabhaskar22/Passwordencryption' ><Card image={pwdencrpt} title='PasswordEncryption' stack='ReactJs, crypto-js' /></a> 
           <a target='_blank' href='https://github.com/leelabhaskar22/E-commerce' ><Card image={ecomimg} title='Ecommerce' stack='ReactJs, Friebase Auth' /></a> 
        </div>
    <div className='projects-card'>
           <a target='_blank' href='https://github.com/leelabhaskar22/E-commerce' ><Card image={fly} title='Flywere' stack="Nextjs14,Tailwind css,Rapid API's" /></a> 
           <a target='_blank' href='https://chatapp-three-livid.vercel.app/' ><Card image={chat} title='Chat-App ' stack="ReactJs,Firebase Auth,Firestore"/></a> 
        </div>
    </div>

    <div id='stack' className='whatiknow section'>
            <h3>What I know</h3>
            <div className='stack-cards'>
                <FrontendStack title="Frontend" />
                <BackendStack />
                <DatabaseStack />
            </div>
        </div>
    </div>
    </section>
        </>
    ) 
}
export default Portfolio;